import React from "react";

import { Counts } from "../../../../models";

import "./DailyDeliveriesCard.scss";

export interface DailyDeliveriesCardProps {
  deliveriesCount: Counts;

  onViewOrders: (ids: string[]) => () => void;
}

export function DailyDeliveriesCard(props: DailyDeliveriesCardProps) {
  const { deliveriesCount, onViewOrders } = props;

  return (
    <div className="daily-deliveries-card-component">
      <div className="header">
        <div className="header-title">Deliveries</div>
      </div>

      <div className="items-container">
        <div
          className="item-container"
          onClick={onViewOrders(deliveriesCount.complete.ids)}
        >
          <div className="item-title">Completed</div>
          <div className="item-value">{deliveriesCount.complete.total}</div>
        </div>

        <div className="vertical-divider" />

        <div
          className="item-container"
          onClick={onViewOrders(deliveriesCount.scheduled.ids)}
        >
          <div className="item-title">Scheduled</div>
          <div className="item-value">{deliveriesCount.scheduled.total}</div>
        </div>

        <div className="vertical-divider" />

        <div
          className="item-container"
          onClick={onViewOrders(deliveriesCount.canceled.ids)}
        >
          <div className="item-title">Canceled</div>
          <div className="item-value">{deliveriesCount.canceled.total}</div>
        </div>
      </div>
    </div>
  );
}
